import { render, staticRenderFns } from "./SessionModalBox.vue?vue&type=template&id=0cfda456&scoped=true&"
import script from "./SessionModalBox.vue?vue&type=script&lang=js&"
export * from "./SessionModalBox.vue?vue&type=script&lang=js&"
import style0 from "./SessionModalBox.vue?vue&type=style&index=0&id=0cfda456&lang=scss&scoped=true&"
import style1 from "./SessionModalBox.vue?vue&type=style&index=1&id=0cfda456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfda456",
  null
  
)

export default component.exports